import customParseFormat from "dayjs/plugin/customParseFormat";
import localizedFormat from "dayjs/plugin/localizedFormat";
import dayjs from "dayjs";
import "dayjs/locale/en.js";
import "dayjs/locale/nb.js";
import "dayjs/locale/nn.js";

export function configureDayjs() {
  dayjs.extend(customParseFormat);
  dayjs.extend(localizedFormat);
  dayjs.locale("nb");
}
